<template>
    <div class="person-quote">
        <div ref="image" class="person-quote__wrapper">
            <button class="button" v-on:click="toggleHandler">Lees quote</button>
        </div>
    </div>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl"

    /* tooltip-quote */
    .person-quote
        display block
        .button
            font-size 1em
    .person-quote__wrapper
        display inline-block
        padding-bottom 8px

    .person-quote__image
        cursor pointer

    .person-quote__action
        position relative
        cursor pointer
        color $color-main-1
        font-size .9em
        margin-top 3px
        text-align center
        text-decoration underline
        &:hover
            text-decoration underline

    .tooltip
        max-width 40%
        background-color $color-main-1
        color #fff
        padding 1em
        margin-bottom 10px
        border-radius 8px

    .tooltip-inner
        line-height 1.4em

    .tooltip-arrow
        border-right: 5px transparent solid;
        border-left: 5px transparent solid;
        left: 50%
        width: 0
        height: 0
        position: absolute;
        .tooltip[x-placement="top"] &
            border-top: 10px $color-main-1 solid;
            bottom: -10px;
        .tooltip[x-placement="bottom"] &
            border-bottom 10px $color-main-1 solid;
            top -10px

</style>
<script>
    import Tooltip from 'tooltip.js';

    export default{
        props: {
            quote: String,
            imgUrl: String
        },
        watch: {
            imgUrl() {
                if (this.imgUrl) {
                    this.initTooltip();
                }
            }
        },
        mounted() {
            this.initTooltip();
        },
        methods: {
            initTooltip() {
                if (this.tooltip) {
                    this.tooltip.dispose();
                }
                const element = this.$refs['image'].$el ? this.$refs['image'].$el : this.$refs['image'];
                this.tooltip = new Tooltip(element, {
                    title: `'${this.quote}'`,
                    placement: 'top',
                    trigger: 'click'
                });
            },
            toggleHandler() {
                this.tooltip.toggle();
            }
        },
        beforeDestroy() {
            if (this.tooltip) {
                    this.tooltip.dispose();
                }
        }
    }
</script>



// WEBPACK FOOTER //
// quote.vue?7e705b04